import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Redux from 'redux'
import Radium, { StyleRoot } from 'radium';
import * as Request from '../tgccRequest';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';
import {Message} from '../Components/Message';



const boxStyle: React.CSSProperties = {
    height: '350px',
    width: '500px',
    position: 'relative',
    margin:'auto',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'BarlowMedium',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    fontSize:'17px',
    color:'#404041',
    borderRadius:'20px',
    '@media (max-width:414px)': {
        width:'350px',
        height:'400px',
        top:'2%'
    },
    '@media (max-width:375px)': {
        width:'325px',
        height:'400px',
        top:'2%'
    },
    '@media (max-width:360px)': {
        width:'315px',
        height:'400px'
    },
    '@media (max-width:320px)': {
        width:'260px',
        height:'400px'
    }
};

const contentBox: React.CSSProperties = {
    border:'1px solid #A6A6A6',
    overflow:'auto',
    height:'92%',
}
const imgStyle: CSSProperties = {
    alignSelf: 'center',
    maxHeight: '35px',
    maxWidth: '70px',
    display: 'flex'
}
const rowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    height: '35px',
}
let szRowStyle = Object.assign( {}, rowStyle, {margin: "0 30px", '@media (max-width:414px)':{margin:'0px 0px'},'@media (max-width:375px)':{margin:'0px 0px'}});
let szTBRowStyle = Object.assign( {}, rowStyle, {margin: "20px 30px",'@media (max-width:414px)':{margin:'15px 0px'}});
let confRowStyle = Object.assign({},rowStyle,{justifyContent:'unset'});
const szTVRowStyle: React.CSSProperties = {
    textAlign:'center'
} 

const labelStyle: React.CSSProperties = {
    display: 'flex',
    letterSpacing: '2px',
    flexShrink: 1,
    flexGrow: 1
}
let szLbStyle = Object.assign({}, labelStyle, { flexBasis: '90px', justifyContent: 'flex-end', marginRight: '3px','@media(max-width:320px)':{fontSize:'12px'}});
const szDivider = Object.assign({}, labelStyle, { flexBasis: '30px'});

const confirmLabel: React.CSSProperties = {
    display:'flex',
    letterSpacing:'2px',
    justifyContent:'flex-end',
    marginRight:'3px'
}
const inputStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    backgroundColor: Tgcc.Styles.inputBackground,
    lineHeight: '18px',
    height: '18px',
    width: '100px',
    marginLeft: '3px',
    padding: '2px',
    fontSize: '13px',
    display: 'flex',
    flexShrink: 1,
    flexGrow: 1
}
let numberStyle = Object.assign({},inputStyle, {width: '40px', textAlign: 'right', marginRight: "10px",'@media (max-width:414px)':{marginRight:'0px'}});
const hrStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    width: '85%',
    margin: '15px 0'
}
const title: React.CSSProperties = {
    textAlign:'center',
    fontSize:'30px',
    marginTop:'10px',
    fontFamily:'BarlowMedium',
    color:'#A6A6A6'
}
const tBankerStyle: React.CSSProperties = {
    textAlign:'center',
}
const selectStyles: React.CSSProperties = {
    height:'22px',
    fontSize:'15px',
    marginTop:'10px'
}
let classicSelectStyle = Object.assign({},selectStyles ,{marginTop:"-5px"})

const trRowStyle: React.CSSProperties = {
    marginBottom:'15px',
    '@media (max-width:414px)': {
        textAlign:'center'
    }
}
let closeStyle = Object.assign({},trRowStyle,{display:'flex', justifyContent:'center'})
const trInput: React.CSSProperties = {
    marginLeft:'10px',
    position:'relative',
    top:'-5px',
    fontFamily:'BarlowMedium',
    '@media (max-width:414px)': {
        marginLeft:'0px',
        top:'0px'
    }
}
const trHeaderStyle: React.CSSProperties = {
    marginBottom:'20px',
    '@media (max-width:414px)': {
        textAlign:'center'
    }
}
const cityStyle: React.CSSProperties = {
    padding:'5px',
    fontFamily:'BarlowMedium',
    '@media (max-width:414px)': {
        width:'200px'
    }
}
const stateStyle: React.CSSProperties = {
    width:'50px',
    marginLeft:'10px',
    padding:'5px',
    fontFamily:'BarlowMedium',
    '@media (max-width:414px)': {
        width:'25px'
    }
}
const zipStyle: React.CSSProperties = {
    width:'75px',
    marginLeft:'10px',
    padding:'5px',
    fontFamily:'BarlowMedium',
    '@media (max-width:414px)': {
        width:'40px'
    }
}

const addressDiv: React.CSSProperties = {
    textAlign:'center'
}
const addressStyle: React.CSSProperties = {
    position:'relative',
    padding:'5px',
    width:'333px',
    margin:'10px auto',
    display:'flex',
    fontFamily:'BarlowMedium',
    '@media (max-width:414px)': {
        width:'300px',
        margin:'10px 0px'
    },
    '@media (max-width:375px)': {
        width:'275px'
    },
    '@media (max-width:320px)': {
        width:'225px',
        margin:'10px -10px'
    }
}

const omegaNumStyle: React.CSSProperties = {
    textAlign:'center'
}
const brStyle:React.CSSProperties = {
    display: 'none',
    '@media(max-width:414px)': {
        display:'block'
    }
}
const quantityDiv: React.CSSProperties = {
    textAlign:'center'
}
const quantityStyle: React.CSSProperties = {
    width:'50px',
    padding:'5px',
    marginLeft:'10px',
    fontFamily:'BarlowMedium'
}

const errStyle: React.CSSProperties = {
    color:'red',
    textAlign:'center',
    fontStyle:'italic'
}
const freeTnote: React.CSSProperties = {
    fontStyle:'italic',
    fontSize:'14px'
}
const sizeTotalNote: React.CSSProperties = {
    textAlign:'center',
    fontSize:'14px',
    marginBottom:'10px'
}
const orderReminderStyle: React.CSSProperties = {
    color:'red'
}
const approveBtn : React.CSSProperties = {
    backgroundColor:'#5E6A74',
    color:'white',
    whiteSpace:'normal',
    height:'40px',
    fontFamily:'BarlowMedium',
}

const editBtn: React.CSSProperties = {
    backgroundColor:'rgb(215, 215, 215)',
    whiteSpace:'normal',
    height:'40px',
    fontFamily:'BarlowMedium',
    width:'80px'
}
const confirmBox: React.CSSProperties = {
    width:'550px',
    height:'500px',
    marginLeft:'-275px',
    left:'50%',
    backgroundColor:'white',
    position:'absolute',
    borderRadius:'20px',
    fontFamily:'BarlowLight',
    zIndex:99,
    color:'rgb(104, 104, 104)'
}
const confirmBtnDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'space-around',
    marginTop:'10%'
}

const confirmData: React.CSSProperties = {
    marginRight:'6%',
    color:'black',
    fontWeight:500
}

const sizeDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'space-around',
    width:'75%',
    margin:'auto'
}

const shippingDiv: React.CSSProperties = {
    textAlign:'center',
    marginTop:'2%'
}

const confirmHdr: React.CSSProperties =  {
    textAlign:'center',
    fontSize:'25px'
}

const address: React.CSSProperties = {
    marginTop:'2%',
    color:'black'
}
const shippingHdr: React.CSSProperties = {
    fontSize:'22px'
}
const address1: React.CSSProperties = {
    color:'black'
}
const confErrDiv: React.CSSProperties = {
    color:'red',
    textAlign:'center'
}
const approveText: React.CSSProperties = {
    textAlign:'center',
    margin:'3% auto',
    width:'75%',
    color:'#E27558'
}
const omegaDiv: React.CSSProperties = {
    marginTop:'15px'
}
const  isBlankOrEmpty = (str: string) => {
    if(!str)
        return true;
    if(!str.trim())
        return true;
    return false;
}

class ServiceProps extends Tgcc.BaseProps {
    icon:string;
    description:any;
    title:string;
    proof: Tgcc.Proof;
}


export class _RealCampusServiceContent extends React.Component<ServiceProps, any> {
    state: any = {
        trFirstName:"",
        trLastName:"",
        trEmail:"",
        omegaAcctNum:"",
        classicPaymentType:"Credit Card",
        closeRosterDate:"",
        error:null,
        type:"",
        quantity:0,
        Small: 0,
        Medium: 0,
        Large: 0,
        XLarge: 0,
        XXL: 0,
        XXXL:0,
        YXSmall: 0,
        YSmall: 0,
        YMedium: 0,
        YLarge: 0,
        YXLarge: 0,
        address:"",
        city:"",
        zipcode:"",
        State:"",
        finished:false,
        check:false,
        shipmentType:""
    }
   
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
   
    handleSelect = (evt: React.FormEvent<HTMLSelectElement>) => {
        evt.stopPropagation();
        this.setState({shirtSize:evt.currentTarget.value});
    }

    tBankerClick = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        var config: Tgcc.PaymentConfig = {type:Tgcc.PaymentTypes.TBanker,address:this.state.address,city:this.state.city,State:this.state.State,zipcode:this.state.zipcode,quantity:this.state.quantity.toString(), closeRosterDate:this.state.closeRosterDate.toString(),shipmentType:this.state.shipmentType};
        this.props.dispatch({type:Tgcc.StateAction.SetPaymentType, payload:config});
        this.approveProof(config);
}

    tviteClick = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        var config:Tgcc.PaymentConfig = {type:Tgcc.PaymentTypes.TVite,trFirstName:this.state.trFirstName,trLastName:this.state.trLastName,trEmail:this.state.trEmail,address:this.state.address,city:this.state.city,State:this.state.State,zipcode:this.state.zipcode,quantity:this.state.quantity.toString(),closeRosterDate:this.state.closeRosterDate.toString()};
        this.props.dispatch({type:Tgcc.StateAction.SetPaymentType, payload:config});
        this.approveProof(config);
     }
    omegaClick = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        var config:Tgcc.PaymentConfig = {
            type:Tgcc.PaymentTypes.Omega,
            trFirstName:this.state.trFirstName,
            trLastName:this.state.trLastName,
            trEmail:this.state.trEmail,
            omegaAcctNum:this.state.omegaAcctNum,
            address:this.state.address,
            city:this.state.city,
            State:this.state.State,
            zipcode:this.state.zipcode,
            quantity:this.state.quantity.toString()};
        this.props.dispatch({type:Tgcc.StateAction.SetPaymentType, payload:config});
        this.approveProof(config);
    }
    classicClick = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        var config: Tgcc.PaymentConfig = {
            type:Tgcc.PaymentTypes.Classic,
              classicPaymentType:this.state.classicPaymentType,
              Small:this.state.Small.toString(),
              Medium:this.state.Medium.toString(),
              Large:this.state.Large.toString(),
              XLarge:this.state.XLarge.toString(),
              XXL:this.state.XXL.toString(),
              XXXL:this.state.XXXL.toString(),
              YXSmall:this.state.YXSmall.toString(), 
              YSmall:this.state.YSmall.toString(),
              YMedium:this.state.YMedium.toString(),
              YLarge:this.state.YLarge.toString(),
              YXLarge:this.state.YXLarge.toString(),
              address:this.state.address,
              city:this.state.city,
              State:this.state.State,
              zipcode:this.state.zipcode,
              quantity:this.getTotalCount().toString()
            }
        this.props.dispatch({type:Tgcc.StateAction.SetPaymentType, payload:config});
        this.approveProof(config);
    }
    checkClassic = (evt:React.FormEvent<HTMLInputElement>) =>{
        evt.stopPropagation();
        if(this.numbersAreValid()){
            this.setState({check:true})
            this.setError("");
        }
        
    } 
    handleTreasureFName = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({trFirstName: evt.currentTarget.value});
    }
    handleTreasureLName = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({trLastName: evt.currentTarget.value});
    } 
    handleTreasureEmail = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({trEmail: evt.currentTarget.value});
    }
    handleOmegaAccount = (evt: React.FormEvent<HTMLInputElement>) => {        
        evt.stopPropagation();
        this.setState({omegaAcctNum: evt.currentTarget.value});
    }
    handleSelectClassicPayment = (evt: React.FormEvent<HTMLSelectElement>) => {
        evt.stopPropagation();
        this.setState({classicPaymentType:evt.currentTarget.value});
    }
    handleFieldChange = (evt: React.FormEvent<HTMLInputElement>) => {
        var fldChange = {};
        if(evt.currentTarget.type == 'number')
            fldChange[evt.currentTarget.name] = parseInt(evt.currentTarget.value);
        else
            fldChange[evt.currentTarget.name] = evt.currentTarget.value;
        this.setState(fldChange, () => { this.numbersAreValid() });
    }
    handleAddressChange = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({address:evt.currentTarget.value});
    }
    handleCityChange = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({city:evt.currentTarget.value});
    }
    handleStateChange = (evt:React.FormEvent<HTMLInputElement>)=> {
        evt.stopPropagation();
        this.setState({State:evt.currentTarget.value});
    }

    handleZipChange = (evt:React.FormEvent<HTMLInputElement>)=> {
        evt.stopPropagation();
        this.setState({zipcode:evt.currentTarget.value});
    }
    handleQuantityChange = (evt:React.FormEvent<HTMLInputElement>)=> {
        evt.stopPropagation();
        this.setState({quantity:evt.currentTarget.value});
    }
    handleCloseRosterDateChange = (evt:React.FormEvent<HTMLInputElement>)=>{
        evt.stopPropagation();
        this.setState({closeRosterDate:evt.currentTarget.value});

    }
    handleShipmentType = (evt:React.FormEvent<HTMLSelectElement>) => {
        evt.stopPropagation();
        this.setState({shipmentType:evt.currentTarget.value});
    }

    getTotalCount = () => {
        return this.state.Small
        + this.state.Medium
        + this.state.Large 
        + this.state.XLarge 
        + this.state.XXL
        + this.state.XXXL
        + this.state.YXSmall 
        + this.state.YSmall 
        + this.state.YMedium 
        + this.state.YLarge 
        + this.state.YXLarge ;
    }
    countsAreNegative = () => {
        return this.state.Small < 0
        || this.state.Medium < 0
        || this.state.Large < 0
        || this.state.XLarge < 0
        || this.state.XXL < 0
        || this.state.XXXL < 0
        || this.state.YXSmall < 0
        || this.state.YSmall < 0
        || this.state.YMedium < 0
        || this.state.YLarge < 0
        || this.state.YXLarge < 0;
    }
    numbersAreValid = () => {
        if(this.countsAreNegative())
            return this.setError('Negative item count is not valid.');
        
        else {
            var totalCt: number = this.getTotalCount();
        }
        return true;
    }
    
    
    approvalFailed = (err: any) => {
        this.setState({error: err});
    }

    finished = () => {
        this.setState({finished:true});
    }

    approveProof = (paymentConfig: Tgcc.PaymentConfig) => {
        if(paymentConfig.type == Tgcc.PaymentTypes.TBanker){
            if(!this.validateTbanker())
                return;
            else {
                Request.approveProof(this.props.state.LoginData,this.props.proof, paymentConfig, this.props.state.UserInfo, this.finished, this.approvalFailed);
            }
        }
        if(paymentConfig.type == Tgcc.PaymentTypes.TVite){
            if(!this.validateTvite())
                return;
            else {
                Request.approveProof(this.props.state.LoginData,this.props.proof, paymentConfig, this.props.state.UserInfo, this.finished, this.approvalFailed);
            }
        }
        if(paymentConfig.type == Tgcc.PaymentTypes.Classic){
            if(!this.numbersAreValid() || !this.validateClassic())
                return;
            else {        
                Request.approveProof(this.props.state.LoginData,this.props.proof, paymentConfig, this.props.state.UserInfo, this.finished, this.approvalFailed);
            }
        }
        if(paymentConfig.type == Tgcc.PaymentTypes.Omega){
            if(!this.validateOmega())
                return;
            else {
                Request.approveProof(this.props.state.LoginData,this.props.proof, paymentConfig, this.props.state.UserInfo, this.finished, this.approvalFailed);
            }
        }
    }
    continue = () => {
        browserHistory.push(Tgcc.Routes.CampusDashboard);
    }
    setError = (msg: string) => {
        this.setState({error: msg});
        return false;
    }

    validateTbanker = () => {
        if(isBlankOrEmpty(this.state.quantity) || this.state.quantity < 24)
            return this.setError("Quantity must be at least 24");
        if(this.state.shipmentType != "Individual Shipment"){
            if(isBlankOrEmpty(this.state.address))
                return this.setError("Please enter an address");
            if(isBlankOrEmpty(this.state.city))
                return this.setError("Please enter a valid city");
            if(isBlankOrEmpty(this.state.State) || this.state.State.length != 2)
                return this.setError("Please enter a valid state");
            if(this.state.zipcode.toString().length != 5)
                return this.setError("Please enter a valid zipcode");
        }
        if(isBlankOrEmpty(this.state.shipmentType))
            return this.setError("Shipment type cannot be blank");
        return true;
    }

    validateTvite = () => {
        if(isBlankOrEmpty(this.state.quantity) || this.state.quantity < 24)
            return this.setError("Quantity must be at least 24");
        if(isBlankOrEmpty(this.state.trFirstName || this.state.trFirstName.length >= 2))
            return this.setError("Please provide your treasurers First Name")
        if(isBlankOrEmpty(this.state.trLastName))
            return this.setError("Please provide your treasurers Last Name")
        if(!Tgcc.IsValidEmail(this.state.trEmail))
            return this.setError("Please provide a valid email")
        if(isBlankOrEmpty(this.state.address))
            return this.setError("Please enter an address");
        if(isBlankOrEmpty(this.state.city))
            return this.setError("Please enter a valid city");
        if(isBlankOrEmpty(this.state.State) || this.state.State.length != 2)
            return this.setError("Please enter a valid state");
        if(this.state.zipcode.toString().length != 5)
            return this.setError("Please enter a valid zipcode");
        return true;
    }
    validateOmega = () => {

        if(isBlankOrEmpty(this.state.omegaAcctNum))
            return this.setError("Please enter a valid omega number");
        if(isBlankOrEmpty(this.state.quantity) || this.state.quantity < 24)
            return this.setError("Quantity must be at least 24");
        if(isBlankOrEmpty(this.state.trFirstName || this.state.trFirstName.length >= 2))
            return this.setError("Please provide your treasurers First Name")
        if(isBlankOrEmpty(this.state.trLastName))
            return this.setError("Please provide your treasurers Last Name")
        if(!Tgcc.IsValidEmail(this.state.trEmail))
            return this.setError("Please provide a valid email")
        if(isBlankOrEmpty(this.state.address))
            return this.setError("Please enter an address");
        if(isBlankOrEmpty(this.state.city))
            return this.setError("Please enter a valid city");
        if(isBlankOrEmpty(this.state.State) || this.state.State.length != 2)
            return this.setError("Please enter a valid state");
        if(this.state.zipcode.toString().length != 5)
            return this.setError("Please enter a valid zipcode");
        return true;
    }

    validateClassic = () => {
        if(this.getTotalCount() < 36 || isNaN(this.getTotalCount()))
            return this.setError("Quantity must be 36.")
        if(isBlankOrEmpty(this.state.address))
            return this.setError("Please enter an address");
        if(isBlankOrEmpty(this.state.city))
            return this.setError("Please enter a valid city");
        if(isBlankOrEmpty(this.state.State) || this.state.State.length != 2)
            return this.setError("Please enter a valid state");
        if(this.state.zipcode.toString().length != 5)
            return this.setError("Please enter a valid zipcode");
        
        return true;
    }


    getThankYou = () => {
        return <Message 
                    Title="Thank You!"         
                    UseTitleScript={true}
                    Message1="You have successfully approved your proof. Your account manager will be in contact with you in regards to your payment information."
                    Message2={"Proof Number: " + this.props.proof.proofId}
                    onContinue={this.continue}
                 />
    }
    close = (evt:React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation()
        this.setState({check:false})
    }
    getConfirmation(){
        if(this.state.check){
            return(
                <div style={confirmBox} className="confirmBox">
                    <div style={confirmHdr}>Confirm Sizes &#38; Shipping Address</div>
                    <div style={confErrDiv}>{this.state.error}</div>
                        <div style={szRowStyle}>
                            <div style={confirmLabel}>Payment Type:</div>
                            <div style={confirmData}>{this.state.classicPaymentType}</div>
                        </div>
                        <div style={sizeDiv}>
                            <div>
                                <div style={confRowStyle}>
                                    <div style={confirmLabel}>Small:</div>
                                    <div style={confirmData}><strong>{this.state.Small}</strong></div>
                                </div>
                                <div style={confRowStyle}>
                                    <div style={confirmLabel}>Medium:</div>
                                    <div style={confirmData}><strong>{this.state.Medium}</strong></div>
                                </div>
                                <div style={confRowStyle}>
                                    <div style={confirmLabel}>Large:</div>
                                    <div style={confirmData}><strong>{this.state.Large}</strong></div>
                                </div>
                            </div>
                            <div>
                                <div style={confRowStyle}>
                                    <div style={confirmLabel}>XLarge:</div>
                                    <div style={confirmData}><strong>{this.state.XLarge}</strong></div>
                                </div>
                                <div style={confRowStyle}>
                                    <div style={confirmLabel}>XXL:</div>
                                    <div style={confirmData}><strong>{this.state.XXL}</strong></div>

                                </div> <div style={confRowStyle}>
                                    <div style={confirmLabel}>XXXL:</div>
                                    <div style={confirmData}><strong>{this.state.XXXL}</strong></div>
                                </div>
                            </div>
                        </div>
                        <div style={szRowStyle}>
                            <div style={confirmLabel}>Quantity:</div>
                            <div style={confirmData}><strong>{this.getTotalCount()}</strong></div>
                        </div>
                        <div style={shippingDiv}>
                                <div style={shippingHdr}>Shipping Address</div>
                                <div style={address}>{this.state.address}</div>
                                <div style={address1}><strong>{this.state.city},{this.state.State},{this.state.zipcode}</strong></div>
                        </div>
                        <div style={approveText}>Approve means that you are confirming that all order information is correct. No order changes can be made beyond this point.</div>
                        <div style={confirmBtnDiv}>
                        <input type='submit' style={editBtn} value="Edit" onClick={this.close}/>
                        <input type="submit" style={approveBtn} className="approveBtn" value="Approve" onClick={this.classicClick}/>
                    </div>
                </div>
            )
        }
    }
    
    getShipmentAddress(){
        if(this.state.shipmentType != "Individual Shipment"){
            return(
                <div>
                    <div style={rowStyle}><hr style={hrStyle}/></div>
                    <div style={addressDiv}>Please provide your Shipping Address:</div>
                    <input type="text" placeholder="123 North Main Street" className="serviceInput" style={addressStyle} onChange={this.handleAddressChange} />
                <div style={szRowStyle}>
                    <input type="text" placeholder="Greenville" className="serviceInput" style={cityStyle} onChange={this.handleCityChange} />
                    <input type="text" placeholder="SC" className="serviceInput" style={stateStyle}onChange={this.handleStateChange} />
                    <input type="number" placeholder="90210" className="serviceInput"style={zipStyle} onChange={this.handleZipChange} />
                </div>
            </div>
            )
        }
    }
    checkServiceType = () => {
        var orderReminder = <div style={orderReminderStyle}><i>By filling out this form, you are authorizing us to print and invoice your order.</i></div>
        if(this.props.title == Tgcc.CampusPaymentTypes.TBanker){
            return ( 
                <div style={tBankerStyle}>
                    <br />            
                    <div style={quantityDiv}>
                     <label>Estimated Quantity:</label>
                     <input type="number" className="serviceInput" style={quantityStyle} onChange={this.handleQuantityChange} min="24"/>
                    </div>
                    <br />            
                    <div style={trRowStyle}>
                        <label>Close Roster Date:</label>
                      <input type="date" style={trInput} className="serviceInput" onChange={this.handleCloseRosterDateChange}/>
                    </div>
                    <div style={szRowStyle}>
                        <label>Shipment Type:</label>
                        <select name="shipmentType" onChange={this.handleShipmentType}>
                            <option value=""></option>
                            <option value="Bulk Shipment">Bulk Shipment</option>
                            <option value="Individual Shipment">Individual Shipment</option>
                            <option value="Combo Shipment">Bulk & Individual</option>
                        </select>
                        
                    </div>
                     <div style={errStyle}>{this.state.error}</div>
                    {this.getShipmentAddress()}                  
                    <div style={szTBRowStyle}>
                        <input type="submit" style={approveBtn} className="approveBtn" value="Approve Design & Submit Payment Info" onClick={this.tBankerClick}/>
                    </div>
                </div>
            )
        } else if (this.props.title == Tgcc.CampusPaymentTypes.TVite){
            return (
                <div>
                    <div style={szTVRowStyle}>
                        <br />
                    </div>
                     <div style={quantityDiv}>
                     <label>Estimated Quantity:</label>
                     <input type="number" className="serviceInput" style={quantityStyle} onChange={this.handleQuantityChange} min="24"/>
                     </div>
                     <br />            
                     <div style={closeStyle}>
                        <label>Close Roster Date:</label>
                      <input type="date" className="serviceInput" style={trInput} onChange={this.handleCloseRosterDateChange}/>
                    </div>
                <div style={rowStyle}><hr style={hrStyle}/></div>
                    <div style={trHeaderStyle}>Please provide your treasurer's information:</div>
                        <div style={trRowStyle}>
                            <label>Treasurer's First Name:</label><input id="treasureFName" type="text" style={trInput} className="serviceInput" onChange={this.handleTreasureFName}/><br />
                        </div>
                        <div style={trRowStyle}>
                            <label>Treasurer's Last Name:</label><input id="treasureLName" type="text" style={trInput} className="serviceInput" onChange={this.handleTreasureLName}/><br />
                        </div>
                        <div style={trRowStyle}>
                            <label>Treasurer's Email:</label><br style={brStyle}/><input id="treasureEmail" type="email" style={trInput}  className="serviceInput" onChange={this.handleTreasureEmail}/><br />
                        </div>
                     <div style={errStyle}>{this.state.error}</div>
                <div style={rowStyle}><hr style={hrStyle}/></div>
                    <div style={addressDiv}>Please provide your Shipping Address:</div>
                    <input type="text" placeholder="123 North Main Street" className="serviceInput" style={addressStyle} onChange={this.handleAddressChange} />
                <div style={szRowStyle}>
                    <input type="text" placeholder="Greenville" className="serviceInput" style={cityStyle} onChange={this.handleCityChange} />
                    <input type="text" placeholder="SC" className="serviceInput" style={stateStyle}onChange={this.handleStateChange} />
                    <input type="number" placeholder="90210" className="serviceInput"style={zipStyle} onChange={this.handleZipChange} />
                </div>
                        <div style={szTBRowStyle}>
                            <input type="submit" style={approveBtn} className="approveBtn" value="Approve Design & Submit Payment Info" onClick={this.tviteClick}/>
                        </div>
                </div>
            )
        } 
        else {
            return (
                <div>
                    <div style={szTVRowStyle}>
                    {orderReminder}
                    <br />
                    </div>
                    <div style={rowStyle}><hr style={hrStyle}/></div>
                    <div style={szRowStyle}>
                        <label>Payment Type:</label>
                        <select onChange={this.handleSelectClassicPayment} value={this.state.classicPaymentType} style={classicSelectStyle}>
                            <option value="Credit Card">Credit Card</option>
                            <option value="Check">Check</option>
                            <option value="Purchase Order">Purchase Order </option>
                        </select>
                    </div>
                 <div style={rowStyle}><hr style={hrStyle}/></div>
                <div style={szRowStyle}>
                    <div style={szLbStyle}>Small:</div>
                    <input type="number" name="Small" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                    <div style={szDivider}></div>
                    <div style={szLbStyle}>XLarge:</div>
                    <input type="number" name="XLarge" placeholder="0"  min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                </div>
                <div style={szRowStyle}>
                    <div style={szLbStyle}>Medium:</div>
                    <input type="number" name="Medium" placeholder="0"  min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                    <div style={szDivider}></div>
                    <div style={szLbStyle}>2XLarge:</div>
                    <input type="number" name="XXL" placeholder="0"  min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                </div>
                <div style={szRowStyle}>
                    <div style={szLbStyle}>Large:</div>
                    <input type="number" name="Large" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                    <div style={szLbStyle}>3XLarge:</div>
                    <input type="number" name="XXXL" placeholder="0" min="0" style={numberStyle} onChange={this.handleFieldChange}/>
                    <div style={szDivider}></div>
                </div>
                 <div style={errStyle}>{this.state.error}</div>
                 <div style={rowStyle}><hr style={hrStyle}/></div>
                    <div style={addressDiv}>Please provide your Shipping Address:</div>
                    <input type="text" placeholder="123 North Main Street" className="serviceInput" style={addressStyle} onChange={this.handleAddressChange} />
                <div style={szRowStyle}>
                    <input type="text" placeholder="Greenville" className="serviceInput" style={cityStyle} onChange={this.handleCityChange} />
                    <input type="text" placeholder="SC" className="serviceInput" style={stateStyle}onChange={this.handleStateChange} />
                    <input type="number" placeholder="90210" className="serviceInput"style={zipStyle} onChange={this.handleZipChange} />
                </div>
                    <div style={szTBRowStyle}>
                        <input type="submit" style={approveBtn} className="approveBtn" value="Approve Design & Submit Payment Info" onClick={this.checkClassic}/>
                    </div>
                </div>
            )
        }
    }
    render() {
        var thankYou = this.state.finished ? this.getThankYou() : null;
        return (
            <ScreenDoor>
                <div style={boxStyle}>
                        <CloseX closeAction={this.cancel} />
                        <div style={title}>{this.props.title}</div>
                        <div style={contentBox}>
                            {this.checkServiceType()}
                        </div>
                </div>
                {this.getConfirmation()}
                 {thankYou}
            </ScreenDoor>
           
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var RealCampusServiceContent = connect(mapStateToProps)(Radium(_RealCampusServiceContent));